export default __webpack_public_path__ + "static/media/key.f83a98c0.svg";